<template>
  <div>
    <div class="col-12 pb-5 mb-4" v-if="pageloader">
      <img src="../../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
    </div>
    <div class="col-lg-12 pb-5 d-flex flex-column" v-if="!pageloader"> 
      <div>
        <div class="row no-gutters pb-5"  v-if="postedVideosList.length<1">
          <div class="col-12 card mb-4 introvideocard borderradius10">
            <div class="row no-gutters p-2" >
              <div class="col p-5 text-center">
                <img src="../../assets/no_video.svg" class="img-md-fluid img-sm-fluid no-video mx-auto pb-4" alt="novideo">
                <div class="col d-flex justify-content-center fontsize16 black60 proximanova">No Video's Found</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-for="(videoitem, index) in postedVideosList" :key="index">
            <div class="card mb-2 borderradius10" :id="'companyPostedVideoCardItem'+index">
              <div class="card-body p-0">
                <div class="d-flex flex-column pb-5">
                  <div class="videocardhead d-flex justify-content-between p-3">
                    <div class="d-flex">
                      <div class="postvideoimage pl-1">
                        <img v-if="videoitem.companylogolink" :src="videoitem.companylogolink" alt="companylogo" oncontextmenu="return false" class="loadingBgImg rounded-circle border border-secondary" width="40px" height="40px">
                        <img v-else src="../../assets/Company_Icon.svg" alt="companyicon" class="rounded-circle border border-secondary" width="40px">
                      </div>
                      <div class="d-flex flex-column pl-2 pr-2 mt-0">
                        <span class="fontsize14 black proximanova-semibold">{{videoitem.companyname}}</span>
                        <span class="black60 proximanova fontsize12">{{videoitem.industry}} - {{videoitem.countryname}}</span>
                      </div>
                      <div class="black60 proximanova fontsize12 pt-1 ml-3">
                        <span v-if="videoitem.empCreationD !== null">{{new Date(videoitem.empCreationD) | moment("from", "now", true)}} ago</span>
                        <!-- <span v-else>{{new Date(videoitem.lastUpdatedD) | moment("from", "now", true)}} ago</span> -->
                      </div>
                    </div>
                    <!-- <div>
                      <img src="../../assets/horizontal_menu_icon.svg" v-popover = "{name: videoitem.moremenuname}" :id="videoitem.moremenuname" width="20px" alt="" class="more_optionmenu moreactionsmenu">
                      <popover v-bind:name="videoitem.moremenuname" class="postvideomenu" id="postvideomenu">
                        <div class="p-2">
                          <div class="d-flex justify-content-between">
                            <span class="black fontsize12 proximanova">More Actions</span>
                            <div class="closebtn11">
                              <img src="../../assets/closebtn.svg" class="img-fluid pr-1 closebtn1" @click="closePostMoreActions(videoitem.moremenuname)">
                            </div>
                          </div>
                          <div class="d-flex p-1 mouseoveraction" @click="editPostVideo(videoitem)">
                            <img src="../../assets/Editvideo.svg" class="img-fluid pl-1 pr-1 ">
                            <span class="pt-1 pl-2 d-flex flex-column">
                              <div class="fontsize14 black80 proximanova">Edit</div>
                            </span>
                          </div>
                          <div class="d-flex p-1 mouseoveraction" >
                            <img src="../../assets/Deletevideo.svg" class="img-fluid pl-1 pr-1">
                            <span class="pt-1 pl-1 d-flex flex-column ml-1">
                              <div class="fontsize14 black80 proximanova">Delete</div> 
                            </span>
                          </div>
                        </div>
                      </popover>
                    </div> -->
                  </div>
                  <div class="videocardbody">
                    <span v-if="videoitem.aspectRatio">
                      <span v-if="videoitem.aspectRatio < 1">
                        <video oncontextmenu="return false" :src="videoitem.empVideoLink" controlsList="nodownload" @loadedmetadata="postvideoMetaLoaded(videoitem, index)" @error ="postvideoLoading(index)" controls muted  class="postedvideoItem portraitvideheight" @pause="VideoPause(videoitem)" v-on:play="VideoPlay(videoitem,index)" :id="'postvideo'+index" preload="metadata" webkit-playsinline playsinline>
                        </video>
                      </span>
                      <span v-if="videoitem.aspectRatio >=1">
                        <video oncontextmenu="return false" :src="videoitem.empVideoLink" controlsList="nodownload" @loadedmetadata="postvideoMetaLoaded(videoitem, index)" @error ="postvideoLoading(index)" controls muted  class="postedvideoItem" @pause="VideoPause(videoitem)" v-on:play="VideoPlay(videoitem,index)" :id="'postvideo'+index" preload="metadata" webkit-playsinline playsinline>
                        </video>
                      </span>
                    </span>
                    <span v-else>
                      <video oncontextmenu="return false" :src="videoitem.empVideoLink" controlsList="nodownload" @loadedmetadata="postvideoMetaLoaded(videoitem, index)" height="400px" @error ="postvideoLoading(index)" controls muted  class="postedvideoItem" @pause="VideoPause(videoitem)" v-on:play="VideoPlay(videoitem,index)" :id="'postvideo'+index" preload="metadata" webkit-playsinline playsinline>
                      </video>
                    </span>
                  </div>
                  <div class="postvideocontent p-1 pb-2 pl-3">
                    <div class="d-flex flex-column pl-2">
                      <span class="proximanova-semibold fontsize16 black80">{{videoitem.empVideoTitle}}</span>
                      <span class="proximanova black60 fontsize14">{{videoitem.empVideoDescription}}</span>
                    </div>
                  </div>
                  <div class="horizonline"></div>
                  <div class="d-flex p-3">
                    <div class="d-flex ml-2">
                      <img src="../../assets/Like.svg" alt="likevideo" title="Like" class="postvideoIcons" v-if="videoitem.likeVideoFlag == 'N'" @click="LikePostedVideo(index, videoitem.id, videoitem.profileId, 'posted')">
                      <img src="../../assets/Likedblue.svg" alt="unlikevideo" title="Unlke" class="postvideoIcons" v-if="videoitem.likeVideoFlag == 'Y'" @click="unlikePostedVideo(index, videoitem.id, 'posted')">
                      <span class="proximanova-semibold fontsize12 black60 pt-1 ml-2" v-if="videoitem.noOfLikes>0">{{videoitem.noOfLikes}}</span>
                      <span class="proximanova-semibold fontsize12 black60 pt-1 ml-2" v-else>00</span>
                    </div>
                    <div class="d-flex ml-lg-5 ml-4">
                      <img src="../../assets/Comment.svg" alt="comment" v-if="videoitem.commentVideoFlag == 'N'" class="postvideoIcons">
                      <img src="../../assets/Commentblue.svg" alt="comment" v-if="videoitem.commentVideoFlag == 'Y'" class="postvideoIcons">
                      <span class="proximanova-semibold fontsize12 black60 pt-1 ml-2" v-if="videoitem.noOfComments>0">{{videoitem.noOfComments}}</span>
                      <span class="proximanova-semibold fontsize12 black60 pt-1 ml-2" v-else>00</span>
                    </div>
                    <div class="d-flex ml-lg-5 ml-4">
                      <img src="../../assets/Share_Video.svg" alt="share" class="postvideoIcons">
                      <span class="proximanova-semibold fontsize12 black60 pt-1 ml-2">00</span>
                    </div>
                    <div class="d-flex ml-lg-5 ml-4">
                      <img src="../../assets/Views.svg" alt="viewvideo" class="postvideoIcons">
                      <span class="proximanova-semibold fontsize12 black60 pt-1 ml-2" v-if="videoitem.noOfViews>0">{{videoitem.noOfViews}}</span>
                      <span class="proximanova-semibold fontsize12 black60 pt-1 ml-2" v-else>00</span>
                    </div>
                  </div>
                  <div class="horizonline1"></div>
                  <div class="commentsection d-flex pt-3 pl-3 pr-3 pb-1">
                    <div class="postvideoimage pl-2">
                      <img v-if="currentUserProfilePicture" :src="currentUserProfilePicture" alt="profilepic" oncontextmenu="return false" class="loadingBgImg rounded-circle img-fluid" width="40px" height="40px">
                      <img v-else src="../../assets/Profile_placehlder.svg" alt="profilepic" class="rounded-circle border border-secondary" width="40px">
                    </div>
                    <div class="commentssection d-flex">
                      <input type="text" v-model="videoitem.commentpostText" @keyup="videoitem.postcommentbtn = true" class="commentssectiontext" placeholder="Add my comment...">
                      <img src="../../assets/commentsend.svg" width="30px" v-if="videoitem.postcommentbtn" height="25px" title="post comment" class="postcommenticon ml-1" alt="savecomment" @click="postComment(index, videoitem)">
                    </div>
                  </div>
                  <div v-if="videoitem.listOfComments">
                    <div v-if="videoitem.listOfComments.length>0">
                      <div v-for="(comment,cmind) in videoitem.listOfComments" :key="cmind">
                        <div class="d-flex pt-3 pl-3 pr-3" v-if="cmind < videoitem.limit_by">
                          <div class="postvideoimage pl-2">
                            <img :src="comment.profilePictureLink" oncontextmenu="return false" alt="profilepic" class="rounded-circle ml-1 loadingBgImg" width="40px" height="40px">
                          </div>
                          <div v-if="companyprofileId !== comment.profileId" class="commentssectiontext2 pl-3 p-2">
                            <div class="d-flex flex-column">
                              <span class="black fontsize12 proximanova">{{comment.firstName}} {{comment.lastName}}</span>
                              <span class="black60 proximanova fontsize12">{{comment.designationName}}, {{comment.country}}</span>
                            </div>
                            <span class="fontsize14 black80 proximanova">{{comment.comment}}</span>
                          </div>
                          <div v-else class="commentssectiontext2 pl-3 p-2">
                            <div class="d-flex justify-content-between">
                              <div class="d-flex flex-column">
                                <span class="black fontsize12 proximanova">{{comment.firstName}} {{comment.lastName}}</span>
                                <span class="black60 proximanova fontsize12">{{comment.designationName}}, {{comment.country}}</span>
                              </div>
                              <div>
                                <img src="../../assets/commentsend.svg" width="28px" height="21px" v-if="comment.iscommentchanged" class="postcommenticon mr-1" title="update comment" alt="updatecomment" @click="updateComment(comment, videoitem)">
                                <img src="../../assets/Delete_Comment.svg" width="28px" height="22px" class="postcommenticon mt-2 mr-2" title="delete comment" alt="deletecomment" @click="deletepostedVideoComment(cmind, comment, videoitem)">
                              </div>
                            </div>
                            <input type="text" class="commentssectiontext3" v-model="comment.comment" @keyup="DisplayPostCommentUpdate(comment)">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="pl-5 pt-3 pb-3">
                      <span class="pl-4 ml-3 fontsize12 proximanova black pointer" v-if="videoitem.listOfComments.length>0 && videoitem.listOfComments.length > videoitem.limit_by" @click="viewAllComments(index)">View all Comments</span>
                      <span class="pl-4 ml-3 fontsize12 proximanova black pointer" v-if="videoitem.listOfComments.length>2 && videoitem.listOfComments.length <= videoitem.limit_by" @click="viewLessComments(index)">View less comments</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal> 
  </div>
</template>
<script>
import httpuserprofile from '@/js/http-userprofile'
import APIerrorModal from '../../components/APIerrorpopup.vue'
import sessionUtils from '@/js/session-util.js'
import $ from 'jquery'
export default{
    data(){
        return{
          pageloader : true,
          instancedataget : false,
          instanceDataFlag : true,
          addintrovideoimage : require('../../assets/Create_Video.svg'),
          postavideomodalopen : false,
          updatepostvideomodalopen : false,
          videoObject : {},
          updateVideoObject : {},
          //details section
          userDetails : null,
          currentUserProfilePicture : null,
          businessAccountId : null,
          companyprofileId : null,
          companyDetails : {},
          postedvideosoffset : 0,
          postedVideosList : [],
          displayAPIerrorModal : false,
        }
    },
    components: {
      APIerrorModal
    },
    methods :{
      closeAPIerrorModal(){
        this.displayAPIerrorModal = false;
      },
      //get user details
      getUserDetails() {
        httpuserprofile.get('/userprofile/userbyid/'+sessionUtils.getUserId())
        .then((response) => {
          this.userDetails = response.data;
          this.currentUserProfilePicture = response.data.profilePictureLink;
        }).catch((e) => {
          console.log(e)
        })
      },
      //get posted videos list
      getPostedVideos : function() {
        var that = this;
        httpuserprofile.get("/userprofile/postedVideosByCompanyProfileId?companyProfileId="+this.companyprofileId+"&limit=10&offset="+this.postedvideosoffset)
        .then((response) => {
          console.log(response)
          this.pageloader = false;
          this.instancedataget = true;
          if(response.data) {
            console.log("company posted videos  : ", response)
            response.data.forEach(function(d, index){               
              d.isPlaying = false;
              d.iscommentsopen = false;
              d.isMuted = false;
              d.postcommentbtn = false;
              d.moremenuname = 'popover'+index;
              d.limit_by = 3;
              d.videoDuration = null;
              d.videoWatched =false;
              d.videoPaused = false;
              d.videoWidth =  null;
              d.videoHeight = null;
              d.aspectRatio = null;
              // if(d.listOfComments.length > 0){
              //   d.listOfComments.forEach(function(c){
              //     c.iscommentchanged = false;
              //   })
              // }
            })
            this.postedVideosList = this.postedVideosList.concat(response.data);
            if(response.data.length > 9){
              this.instanceDataFlag = true;
            }else{
              this.instanceDataFlag = false;
            }
          }
        }).catch((e) => {
          console.log(e)
          this.instancedataget = true;
          this.instanceDataFlag = false;
        })
      },
      
      closePostMoreActions : function(id) {
        document.getElementById(id).click()
      },
      postvideoMetaLoaded(video,index){
        var videoElement = document.getElementById("postvideo"+index); 
        video.videoWidth = videoElement.videoWidth;
        video.videoHeight = videoElement.videoHeight;
        video.aspectRatio = videoElement.videoWidth/videoElement.videoHeight;
      },
      postvideoLoading : function(index) {
        this.postedVideosList[index].empVideoLink = null
      },
      VideoPause  :function(videoitem) {
        videoitem.videoPaused = true;
      },
      VideoPlay  :function(videoitem, index) {
        var video = document.getElementById("postvideo"+index);
        videoitem.videoDuration = video.duration;
        videoitem.videoPaused = false;
        var currentTime = videoitem.videoDuration * (50/100);     
        var self= this                         
        video.ontimeupdate = function(){
          if(currentTime < video.currentTime && !videoitem.videoWatched){
            videoitem.videoWatched = true;
            //call api to update video views               
            // self.viewVideo(videoitem);
          }        
        }
        video.onended = function() {
          var nextIndex = index + 1;
          var nextVideo = document.getElementById("companyPostedVideoCardItem"+nextIndex);
          if(nextVideo){
            nextVideo.scrollIntoView()
          }
        }
      },
      postComment : function(index, viditem){
        console.log("comment on video : ", viditem)
        var fd = new FormData();
        console.log("post type comment")
        var obj = {
          profileId : this.profileId,
          videoId: viditem.id,
          videoProfileId: viditem.userDetailsVo.profileId,
          comments: viditem.commentpostText
        }
        var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
        fd.append("userVideoComments", blob)
        // httpuserprofile.post("/userprofile/commentOnVideo", fd, {
        //   headers: {
        //     "Content-Type": "multipart/form-data",
        //     "Accept" : "*/*"
        //   }
        // }).then((response) => {
        //     if(sectionType === 'posted'){
        //       console.log("comment posted vid : ", response)
        //       this.postedVideosList[index].commentpostText = '';
        //       this.postedVideosList[index].postcommentbtn = false;
        //       this.postedVideosList[index].commentVideoFlag = 'Y'
        //       response.data.listOfComments.forEach(function(c){
        //         c.iscommentchanged = false;
        //       })
        //       this.postedVideosList[index].listOfComments = response.data.listOfComments
        //       this.postedVideosList[index].noOfComments = response.data.noOfComments
        //     }
        // }).catch((e) => {
        //   console.log(e)
        // })
      },
      updateComment : function(comment, viditem) {
        console.log("comment : ", comment)
        var fd = new FormData();
        var obj = {
          id : comment.commentId,
          profileId : this.profileId,
          videoId: viditem.id,
          videoProfileId: viditem.userDetailsVo.profileId,
          comments: comment.comment
        }
        var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
        fd.append("userVideoComments", blob)
        // httpuserprofile.put("/userprofile/updateComment", fd, {
        //   headers: {
        //     "Content-Type": "multipart/form-data",
        //     "Accept" : "*/*"
        //   }
        // }).then((response) => {
        //     console.log("comment update response : ", response)
        //     comment.iscommentchanged = false;
        // }).catch((e) => {
        //   console.log(e)
        // })
      },
      deletepostedVideoComment : function(cmind, comment, videoItem) {
        // httpuserprofile.delete("/userprofile/deleteCommentOnVideo?commentId="+comment.commentId)
        // .then((response) => {
        //     console.log("delete response : ", response)
        //     videoItem.listOfComments.splice(cmind, 1)
        //     videoItem.noOfComments = videoItem.noOfComments-1
        // }).catch((e) => {
        //   console.log(e)
        // })
      },
      DisplayPostCommentUpdate : function(comment){
        console.log(Comment)
        comment.iscommentchanged = true;
      },
      viewAllComments: function(index) {
        var x = this.postedVideosList[index]
        if(x.iscommentsopen){
          x.iscommentsopen = false
        }else{
          x.iscommentsopen = true
        }
        this.postedVideosList[index].limit_by = this.postedVideosList[index].limit_by+3;  
      },
      viewLessComments : function(index) {
        var x = this.postedVideosList[index]
        if(x.iscommentsopen){
          x.iscommentsopen = false
        }else{
          x.iscommentsopen = true
        }
        this.postedVideosList[index].limit_by = 3;
      },
      handleScroll() {
        let scrollPosition = window.scrollY
        var self = this;
        // console.log(scrollPosition)
        if(this.instanceDataFlag){
          if(this.instancedataget){
            if ((window.innerHeight + window.scrollY+1) >= document.body.offsetHeight) {
                this.postedvideosoffset += 10;
                this.instancedataget = false;
                this.instanceDataFlag = false;
                console.log("again calling")
                this.getPostedVideos()
            }
          }
        }
        var media;
        media = $('.postedvideoItem').not("[autoplay='autoplay']");
        autoplay()
        function autoplay() {
          var tolerancePixel = 100;
          var scrollTop = $(window).scrollTop() + tolerancePixel;
          var scrollBottom = $(window).scrollTop() + $(window).height() - tolerancePixel;
          var playPromise;
          media.each(function(index, el) {
            var yTopMedia = $(this).offset().top;
            var yBottomMedia = $(this).height() + yTopMedia;
            if(scrollTop < yBottomMedia && scrollBottom > yTopMedia){ //view explaination in `In brief` section above                    
              playPromise = $(this).get(0).play();
              if(playPromise !== undefined){
                playPromise.then(_ => {
                  $(this).get(0).play();
                })
                .catch(error => {
                });
              }
            } else {
              $(this).get(0).pause();
            }
          });
        }
      },
    },
    mounted(){
      $('[data-toggle="tooltip"]').tooltip();
      this.businessAccountId = this.$session.get("business_account_id")
      this.companyprofileId = this.$session.get("company_profile_id")
      //fetch data
      this.getUserDetails()
      this.getPostedVideos()
      window.addEventListener('scroll', this.handleScroll); 
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    }
}
</script>
<style scoped>
/* video card styles */
.loadingBgImg{
  background: transparent url('../../assets/loading_gif1.gif') center no-repeat;
  background-size: 20px 20px;
}
.videocardbody {
    position: relative;
    width: 100%;
    height: 100%;
    /* //padding: 20px; */
    background-attachment: scroll;
    overflow: hidden;
    background: black;
}
.videocardbody video {
    min-width: 100%;
    min-height: 100%;
    width: 100%;
    position: relative;
    z-index: 1;
    margin-bottom: -1%;
}
.videocardbody .overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    margin-top: 0px !important;
    z-index: 2;
    background: rgba(31, 31, 31, .6);
    /* background: linear-gradient(0deg, rgba(0,0,0,0) 0%, #000000 100%); */
    /* background: linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 50%); */
    opacity: 0.5;
    /* margin-top: -5px; */
}
.closebtn1{
  cursor: pointer;
  width: 15px;
  height: 15px;
  margin-top: -3px;
}
.closebtn11:hover{
  background-color: rgba(161, 166, 179,0.3);
  padding: 0 2px 0 5px;
  border-radius: 50%;
}
.portraitvideheight{
  height: 500px;
}
.horizonline{
  margin-left: 20px;
  margin-right: 20px;
  border-bottom: 1px solid #E9EBF0;
}
.horizonline1{
  border-bottom: 1px solid #E9EBF0;
}
.commentssection{
  width: 100%;
}
.commentssectiontext {
  width: 80%;
  padding: 4px;
  padding-left: 8px;
  margin-left: 4%;
  margin-top: 2px;
  border-radius: 15px;
  border: none;
  background-color: #F0F2F5;
  color: rgba(31, 31, 31, .6);
}
.pageloader {
    width: 10%;
    margin-top: 10%;
    margin-left: 46%;
  }
.postcommenticon{
  margin-right: -5px;
  margin-top: 8px;
  cursor: pointer;
}
.commentssectiontext:focus{
  outline: none;
  box-shadow: none;
}
.pillbtn {
  cursor: pointer;
  border: 1px solid #dbdbdb;
  border-radius: 16px;
  padding-left: 8px !important;
  padding-right: 9px !important;
}
.activeVideoSub {
  background-color: #d6e9ff;
  border: 1px solid #9ecbff;
  color: #0078ff;
}
.pillbtn:hover {
  background-color: rgba(161, 166, 179,0.1);
  border: 1px solid rgba(161, 166, 179,.5);
  /* font-weight: bold; */
}
.myvideosection {
  overflow: auto;
  white-space: nowrap;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
.myvideosection span{
  display: inline-block;
  text-align: center;
  /* padding: 14px; */
  text-decoration: none;
}
.myvideosection::-webkit-scrollbar {
  display: none;
}
.commentssectiontext1{
  width: 70%;
  /* margin-left: 12% !important; */
  padding: 4px;
  padding-left: 8px;
  margin-left: 4%;
  margin-top: 2px;
  border-radius: 15px;
  border: none;
  background-color: #F0F2F5;
  color: rgba(31, 31, 31, .6);
}
.commentssectiontext1:focus{
  outline: none;
  box-shadow: none;
}
.commentssectiontext3{
  width: 100%;
  margin-top: 2px;
  border: none;
  background-color: #F0F2F5;
  color: rgba(31, 31, 31, .6);
}
.commentssectiontext3:focus{
  outline: none;
  box-shadow: none;
}
.commentssectiontext2{
  width: 80%;
  padding: 4px;
  padding-left: 12px;
  margin-left: 3%;
  border-radius: 0 15px 15px 15px;
  background-color: #F0F2F5;
}
.moreactionsmenu {
  width: 25px;
  padding: 3px;
  border: 1px solid white;
}
.moreactionsmenu:hover{
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 50%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.postvideomenu.vue-popover.dropdown-position-bottom:before{
    display: none;
}
.postvideomenu.dropdown-position-bottom {
  left: unset !important;
  top: 35px !important;
  width: 150px !important;
  padding: 10px 10px 10px 10px !important;
  transform: translate3d(-70%, 10px, 10px) !important;
}
.closebtn {
  cursor: pointer;
  width: 15px;
  height: 15px;
  margin-top: -3px;
}
@media only screen and (max-width: 600px){
  .pageloader {
    width: 20%;
    margin-top: 25%;
  }
}
</style>
